export const removeEmpty = (arr: any[] = []) => {
  return arr.filter((el) => el);
};

export const stringToArray = (text: string, splitText: string = " ") => {
  return removeEmpty(text?.split(splitText));
};
